function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 20.1864C12 24.7446 13.761 29.116 16.8955 32.3391C20.03 35.5622 24.2814 37.3729 28.7143 37.3729C33.1472 37.3729 37.3985 35.5622 40.533 32.3391C43.6676 29.116 45.4285 24.7446 45.4285 20.1864C45.4285 15.6283 43.6676 11.2569 40.533 8.03379C37.3985 4.81071 33.1472 3 28.7143 3C24.2814 3 20.03 4.81071 16.8955 8.03379C13.761 11.2569 12 15.6283 12 20.1864Z",
  stroke: "white",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3 81V72.1864C3 67.5114 4.76096 63.0279 7.89549 59.7222C11.03 56.4165 15.2814 54.5593 19.7143 54.5593H36.4285",
  stroke: "white",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M40.2856 72.4067L48.8571 80.9999L65.9999 63.8135",
  stroke: "white",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgCleanName = function SvgCleanName(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 84,
    viewBox: "0 0 69 84",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCleanName, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clean_name.e999d268.svg";
export { ForwardRef as ReactComponent };